// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_R4I","cls2":"ReferenceEvaluationPage-cls2_n4c ReferenceEvaluationPage-cls1_R4I"};